import { useState, useCallback } from 'react'
import customAxios from 'routes/Pages/util/Api'
import authHeader from 'services/auth/jwt/auth-header'

let cachePromise = null

const loadCustomers = () => {
    if (!cachePromise) {
        cachePromise = customAxios
            .post('/Ops/GetCustomerWeighbridgeDetails', {}, { headers: authHeader() })
            .then(({ data }) =>
                (data ?? []).map((item) => ({
                    value: item.customerName,
                    label: item.customerName,
                }))
            )
            .catch((err) => {
                cachePromise = null // allow retry after a failure
                throw err
            })
    }
    return cachePromise
}

export function useGetCustomers() {
    const [customers, setCustomers] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const fetchCustomers = useCallback(async () => {
        setIsLoading(true)
        try {
            setCustomers(await loadCustomers())
        } finally {
            setIsLoading(false)
        }
    }, [])

    return { customers, isLoading, fetchCustomers }
}